import React, { Component } from 'react'
import DataTable from '../../../components/Table/DataTable';
import NavPills from "components/NavPills/NavPills.jsx";

class ReportResults extends Component {
    render() {

        if (this.props.cache && this.props.cache.length > 1) {
            return (
                <NavPills
                    // swipeableSlideStyles={{ padding: 20 }}
                    // tabsStyles={{ marginTop: 0 }}
                    color="success"
                    tabs={this.props.cache.map(
                        result => 
                        ({
                            tabButton: result.name,
                            tabContent: (
                                <DataTable
                                    title={result.name}
                                    data={result.data}
                                    columns={result.headers}
                                />
                            )
                        })
                    )}
                />
            );
        }

        var singleResult = (this.props.cache && this.props.cache[0]) || { name: "No Results", data: [], headers: [] };

        return (
            <DataTable
                title={singleResult.name}
                data={singleResult.data}
                columns={singleResult.headers}
            />
        )
    }
}

export default ReportResults